<template>
  <div id="home" v-if="flashingScreen" v-cloak :class="{ h5: this.$store.state.webType === 'h5' }">
    <el-row :span="24" class="page">
      <el-col :span="24">
        <el-carousel
          trigger="click"
          :height="bannerHeight + 'px'"
          :initial-index="currentIndex"
          ref="homeCarousel"
          @change="changeBanner"
          indicator-position="none"
        >
          <!-- 轮播图示例 -->
          <el-carousel-item v-for="(banner, bdn) in homeInfo.banners" :key="bdn">
            <div
              class="banner-bg"
              :style="{
                background: `url('https://www.wfuca.org/prod-api${banner.coverImage}') no-repeat  center`,
                backgroundSize: '100% auto',
              }"
            >
              <div class="banner-info">
                <div class="info-title">
                  {{ banner.title }}
                </div>
                <div class="info-content">
                  {{ banner.brief }}
                </div>
                <div class="info-btn" @click="clickBannerMore(banner)">
                  Read more <i class="el-icon-right"></i>
                </div>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
        <div class="col-text" v-if="$store.state.webType === 'h5'">
          <template v-for="(banner, bdx) in bannerList">
            <div
              v-show="currentIndex == bdx"
              @click="changeBanner(bdx)"
              class="text-item"
              :class="{ active: currentIndex == bdx }"
            >
              <div class="two-line">
                {{ $store.state.lang == "CN" ? banner.title : banner.titleEnglish }}
              </div>
            </div>
          </template>
        </div>
        <div class="banner-col"></div>
      </el-col>
    </el-row>
    <el-row :span="24" class="page-content">
      <div class="index-title custom_class">Program</div>
      <div class="program-view">
        <div class="program-item" v-for="(item, index) in homeInfo.programs" :key="item.id">
          <img class="item-bg" :src="item.img" />
          <!-- <img class="item-bg" src="@/assets/images/home/contentImg.png" /> -->
          <div class="item-info">
            <div class="item-title custom_program">{{ item.name }}</div>
            <div class="item-btn" @click="$goDetail(item.id, 'programs')">
              Read more <i class="el-icon-right"></i>
            </div>
          </div>
        </div>
        <!-- <div class="program-item">
          <img class="item-bg" src="../assets/images/rwgs-bg.png" />
          <div class="item-info">
            <div class="item-title">Little Legacy Storytellers</div>
            <div class="item-content">
              World Federation of UNESCO Clubs, Centres and Associations (WFUCA)
              is a non-governmental organization in official partnership
              (associate status) with UNESCO having its office at Bonvin
              Building in Paris.
            </div>
            <div class="item-btn">Read more <i class="el-icon-right"></i></div>
          </div>
        </div>
        <div class="program-item">
          <img class="item-bg" src="../assets/images/rwgs-bg.png" />
          <div class="item-info">
            <div class="item-title">Little Legacy Storytellers</div>
            <div class="item-content">
              World Federation of UNESCO Clubs, Centres and Associations (WFUCA)
              is a non-governmental organization in official partnership
              (associate status) with UNESCO having its office at Bonvin
              Building in Paris.
            </div>
            <div class="item-btn">Read more <i class="el-icon-right"></i></div>
          </div>
        </div> -->
      </div>
    </el-row>

    <el-row :span="24" class="all-line blue">
      <div class="program-view2">
        <template v-for="(item, index) in homeInfo.columnContents">
          <div class="program-item" v-if="index === 0">
            <div class="item-info">
              <div class="item-title custom_about">About Us</div>
              <div class="item-title2">{{ item.column }}</div>
              <div class="item-content">
                {{ item.content }}
              </div>
              <div class="item-btn" @click="$goPage('/about')">
                Read more <i class="el-icon-right"></i>
              </div>
            </div>
            <img class="item-bg" :src="item.img" />
          </div>
        </template>
        <!-- <template v-for="(item, index) in homeInfo.columnContents">
          <div class="program-item" v-if="index === 0">
            <img class="item-bg" :src="item.img" />
            <div class="item-info">
              <div class="item-title">{{ item.column }}</div>
              <div class="item-content">
                {{ item.content }}
              </div>
              <div class="item-btn" @click="$goPage('/about')">
                Read more <i class="el-icon-right"></i>
              </div>
            </div>
          </div>
        </template>

        <template v-for="(item, index) in homeInfo.columnContents">
          <div class="program-item" v-if="index === 1">
            <img
              class="item-bg"
              :src="item.img"
              v-if="currentViewType === 'h5'"
            />
            <div class="item-info">
              <div class="item-title">{{ item.column }}</div>
              <div class="item-content">
                {{ item.content }}
              </div>
              <div class="item-btn" @click="$goPage('/clubs')">
                Read more <i class="el-icon-right"></i>
              </div>
            </div>
            <img
              class="item-bg"
              :src="item.img"
              v-if="currentViewType !== 'h5'"
            />
          </div>
        </template> -->
      </div>
    </el-row>
    <el-row :span="24" class="all-line blue">
      <div class="ship-view">
        <div class="ship-item" @click="$goPage('/clubs')">
          <img class="item-bg" :src="homeInfo.columnContents[1].img" />
          <p class="item-title">{{ homeInfo.columnContents[1].column }}</p>
        </div>
        <div class="ship-item" @click="$goPage('/membership')">
          <img src="@/assets/images/home/index-ship01.png" />
          <div class="item-title" style="cursor: pointer" @click="$goPage('/membership')">
            Membership
          </div>
        </div>
        <div class="ship-item" @click="$goPage('/partnership')">
          <img src="@/assets/images/home/index-ship02.png" />
          <div class="item-title" style="cursor: pointer">Partnership</div>
        </div>
      </div>
      <!-- <div class="ship-view">
        <div class="ship-item">
          <img src="@/assets/images/home/index-ship01.png" />
          <div class="item-title" style="cursor: pointer" @click="$goPage('/membership')">
            Membership
          </div>
          <img class="ship-icon" src="@/assets/images/home/ship-icon01.png" />
        </div>
        <div class="ship-item" @click="$goPage('/partnership')">
          <img src="@/assets/images/home/index-ship02.png" />
          <div class="item-title" style="cursor: pointer">Partnership</div>
          <img class="ship-icon" src="@/assets/images/home/ship-icon02.png" />
        </div>
      </div> -->
    </el-row>
    <el-row :span="24" class="page-content cus_two">
      <div class="calendar-view">
        <div class="index-title">Calendar</div>
        <!--banner轮播-->
        <swiper
          :options="this.$store.state.webType === 'h5' ? swiperOptionsH5 : swiperOptions"
          ref="mySwiper"
        >
          <swiper-slide v-for="slide in homeInfo.calendar" :key="slide.aId">
            <!-- I'm Slide {{ slide }} -->
            <div class="calendar-item" @click="$goDetail(slide.aId, 'events')">
              <div class="item-time">
                <img class="icon01" src="@/assets/images/home/calendar-01.png" />
                <img class="icon11" src="@/assets/images/home/calendar-11.png" />
                <div class="time-text">
                  <div class="year">{{ slide.time.split(",")[1] }}</div>
                  <div class="day">
                    {{ slide.time.split(" ")[1].split(",")[0] }}
                  </div>
                  <div class="month">{{ slide.time.split(" ")[0] }}</div>
                </div>
              </div>
              <div class="item-text">
                {{ slide.application }}
              </div>
            </div>
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
        <div class="swiper-button-prev">
          <i class="el-icon-arrow-left"></i>
        </div>
        <!--左箭头。如果放置在swiper-container外面，需要自定义样式。-->
        <div class="swiper-button-next">
          <i class="el-icon-arrow-right"></i>
        </div>
        <!--右箭头。如果放置在swiper-container外面，需要自定义样式。-->
        <div class="more-btn" @click="goEvents">View all <i class="el-icon-right"></i></div>
      </div>
      <div class="index-title news">News</div>
      <div class="news-view">
        <div class="news-content">
          <div class="news-item" v-for="(item, index) in homeInfo.news" :key="index">
            <div class="img-view">
              <img :src="item.coverImage" />
            </div>
            <div class="news-title" @click="$goDetail(item.aId, 'news')">
              {{ item.title }}
            </div>
            <div class="news-date">{{ item.time }}</div>
          </div>
        </div>

        <div class="more-btn" @click="$goPage('/news')">View all <i class="el-icon-right"></i></div>
      </div>
    </el-row>

    <el-row :span="24" class="all-line media">
      <div class="media-view">
        <div class="media-title custom_mud">Multimedia Gallery</div>
        <div class="media-content">
          <template v-for="(item, index) in homeInfo.multimedias">
            <div
              :key="index"
              class="media-item"
              v-if="index <= 4"
              :class="{
                item1: index === 0,
                item2: index === 1,
                item3: index === 2,
                item4: index === 3,
                item5: index === 4,
              }"
            >
              <div class="model">
                <img
                  @click="handleDrawerShow(item)"
                  src="@/assets/images/home/index-play.png"
                  alt=""
                />
              </div>
              <video v-if="item.num === 1" class="media-img" :src="item.href"></video>
              <img v-else class="media-img" @click="handleDrawerShow(item)" :src="item.href" />
            </div>
          </template>
        </div>

        <div class="more-btn" @click="$goPage('/multimedia')">
          View all <i class="el-icon-right"></i>
        </div>
      </div>
    </el-row>
    <div class="home-bottom"></div>

    <el-drawer
      class="drawer-fixed"
      title=""
      :visible.sync="drawer"
      direction="ttb"
      :before-close="handleClose"
    >
      <div class="drawer-view">
        <video
          class="drawer-media"
          v-if="currentItem.type == '1'"
          :src="currentItem.href"
          controls
        ></video>
        <img v-else width="drawer-media" :src="currentItem.href" />
        <div class="info">
          <h2>{{ currentItem.title }}</h2>
          <div class="date">
            {{ currentItem.time }}
          </div>
          <div class="a" @click="$goDetail(currentItem.aId, 'news')">
            {{ currentItem.source }}
          </div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
// 引入Swiper组件和样式
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
export default {
  name: "Home",
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      drawer: false,
      currentItem: {
        href: "https://xunli-ymy.oss-cn-beijing.aliyuncs.com/video/20221026193248.mp4",
        aId: "",
        title: "",
        source: "",
        type: "1",
      },
      homeInfo: {},
      // 解决闪屏问题
      flashingScreen: false,
      currentDate: new Date(),
      swiperOptions: {
        // 这里配置Swiper参数
        // 例如：自动播放、分页等
        // 展示多少张图片
        slidesPerView: 3,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          prevButton: ".swiper-button-prev",
          nextButton: ".swiper-button-next",
        },
        // nextButton: ".swiper-button-next",
        // prevButton: ".swiper-button-prev",
        paginationClickable: true,
        spaceBetween: 0,
        // 其他配置...
      },
      swiperOptionsH5: {
        // 这里配置Swiper参数
        // 例如：自动播放、分页等
        // 展示多少张图片
        slidesPerView: 1,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          prevButton: ".swiper-button-prev",
          nextButton: ".swiper-button-next",
        },
        // nextButton: ".swiper-button-next",
        // prevButton: ".swiper-button-prev",
        paginationClickable: true,
        spaceBetween: 0,
        // 其他配置...
      },

      // 当前展示的banner index
      currentIndex: 0,
      bannerList: [],
      catData: [],
      currentNumIndex: 0,
      numSayData: [],
      imgSayData: [],
      advertiseDatA: [],
      bannerHeight: 0, // 轮播图容器高度;
      bannerHeight2: 0, // 轮播图容器高度;
      screenWidth: 0, // 页面宽度
      currentViewType: "",
    };
  },
  created() {
    //  console.log(this.$appType.name);
    // 首次加载时,初始化高度
    this.screenWidth = window.innerWidth;
    this.bannerHeight = (850 / 1920) * this.screenWidth;
    this.bannerHeight2 = (440 / 1920) * this.screenWidth;
    if (this.$store.state.webType === "h5") {
      this.bannerHeight += 40;
    }
    // 窗口大小发生改变
    window.onresize = () => {
      this.screenWidth = window.innerWidth;
      this.bannerHeight = (850 / 1920) * this.screenWidth;
      this.bannerHeight2 = (440 / 1920) * this.screenWidth;
      console.log(this.$store.state.webType, "this.$store.state.webType");
      if (this.$store.state.webType === "h5") {
        this.bannerHeight += 40;
      }
    };
    // this.getHomeInfo();
  },
  mounted() {
    this.getHomeInfo();
    console.log(window.innerWidth, " this.screenWidth = window.innerWidth;");
    if (window.innerWidth < 500) {
      this.currentViewType = "h5";
    } else {
      this.currentViewType = "";
    }
    // Swiper.use([Navigation, Pagination, Autoplay]);
    // var mySwiper = new Swiper("#mySwiper", swiperOptions);
    this.$nextTick(() => {
      setTimeout(() => {
        this.flashingScreen = true;
      }, 300);
    });
  },
  computed: {},
  methods: {
    clickBannerMore(row) {
      if (row.type == 2) {
        this.$goDetail(row.aId, "Events");
      } else if (row.type == 1) {
        this.$goDetail(row.aId, "news");
      }
    },
    handleClose() {
      this.drawer = false;
    },
    goEvents() {
      this.$router.push({ path: "/news", query: { type: "Events" } });
    },
    handleDrawerShow(item) {
      this.currentItem = item;
      this.drawer = true;
    },
    goAd(link) {
      return;
      window.open(link, "_blank");
    },
    async getHomeInfo() {
      await this.$get(`${this.$api}/un/web/home`, {
        language: "EN",
      }).then((res) => {
        //  console.log(res);
        this.homeInfo = res.data;
        // console.log(JSON.stringify(this.homeInfo));
        // this.catData = res.data.catData;
        // this.bannerList = res.data.bannerList;
        // this.imgSayData = res.data.imgSayData;
        // this.numSayData = res.data.numSayData;
        // this.advertiseDatA = res.data.advertiseDatA;

        // this.jsfbList = res.data.jsfbList;
        // this.cxsmList = res.data.cxsmList;
        // this.zggjcList = res.data.zggjcList;
        // this.sdjdList = res.data.sdjdList;
        // this.xzcList = res.data.xzcList;
        // this.xsddzgrList = res.data.xsddzgrList;

        // this.ddzgList = res.data.ddzgList;
        // this.tsList = res.data.tsList;
        // this.ssList = res.data.ssList;
        // this.zggsList = res.data.zggsList;
        // this.wzyyList = res.data.wzyyList;
      });
    },
    changeBanner(index) {},
    changeNumShow(index) {
      //  console.log(index);
      this.$refs.carousel.setActiveItem(index);
      this.currentNumIndex = index;
      this.$nextTick(() => {
        const ref = `num${index}Ref`;
        // 获取myTabRef的DOM元素，即类名为my-tab的标签
        const line = this.$refs.myLineRef;
        const view = this.$refs.titleView;
        // 获取当前点击的某一个tab的的DOM元素，即类名为my-tab-item的标签
        const active = this.$refs[ref][0].style;
        // console.log(line, active);
        if (this.$store.state.webType === "h5") {
          if (index > 0) {
            if (index >= this.numSayData.length - 1) {
              line.style.transform = `translateX(-${line.offsetWidth - view.offsetWidth - 20}px)`;
            } else {
              line.style.transform = `translateX(-${(index / this.numSayData.length) * 100}%)`;
            }
          } else if (index === 0) {
            line.style.transform = `translateX(-${0}%)`;
          }
        } else if (index > 2 && this.numSayData.length - index > 0) {
          if (index >= this.numSayData.length - 2) {
            line.style.transform = `translateX(-${line.offsetWidth - view.offsetWidth - 20}px)`;
          } else {
            line.style.transform = `translateX(-${((index - 2) / this.numSayData.length) * 100}%)`;
          }

          // let num = this.getTranslateX(document.querySelector(".view-max"));
          // line.style.transform = `translateX(${num - 20 * 10}}px)`;
        } else if (index === 0) {
          line.style.transform = `translateX(-${0}%)`;
        }

        // console.log(nav.offsetWidth, title.offsetLeft);
        // console.log("nav", nav, title);
        // 计算位移偏差
        // const to = title.offsetLeft - (nav.offsetWidth - title.offsetWidth) / 2;
        // console.log(to);
        // console.log(title.offsetLeft, title.offsetWidth);
        // active.left = title.offsetLeft + title.offsetWidth / 2 + "px";
        // active.scrollLeft = to;
      });
    },
    getTranslateX(myElement) {
      const style = window.getComputedStyle(myElement);
      const matrix = new WebKitCSSMatrix(style.webkitTransform);
      //  console.log('translateX: ', matrix.m41);
    },
    // 滑动
    scrollLeftTo(name) {
      this.$nextTick(() => {
        const ref = `tab${name}Ref`;
        // 获取myTabRef的DOM元素，即类名为my-tab的标签
        const nav = this.$refs.myTabRef;
        const active = this.$refs.navActive.style;

        // 获取当前点击的某一个tab的的DOM元素，即类名为my-tab-item的标签
        const title = this.$refs[ref][0];
        // console.log(nav.offsetWidth, title.offsetLeft);
        // console.log("nav", nav, title);
        // 计算位移偏差
        const to = title.offsetLeft - (nav.offsetWidth - title.offsetWidth) / 2;
        // console.log(to);
        // console.log(title.offsetLeft, title.offsetWidth);
        active.left = `${title.offsetLeft + title.offsetWidth / 2}px`;
        // active.scrollLeft = to;
      });
    },
  },
};
</script>
<style>
[v-cloak] {
  display: none;
}
</style>
<style lang="scss" scoped>
.swiper-button-prev,
.swiper-button-next {
  background-image: none;
  height: 100%;
  position: absolute;
  margin: 0;
  top: 0;
  z-index: 999;
}
.swiper-button-prev {
  left: -60px;
  position: absolute;
  top: calc(50% + 30px);
  transform: translateY(-50%);
  display: inline-block;
  border-width: 10px;
  background-color: #f2f2f2;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  color: #00a0e1;
  line-height: 60px;
  font-size: 36px;
  text-align: center;
  &:hover {
    background-color: #00a0e1;
    color: #fff;
  }
}
.swiper-button-next {
  right: -70px;
  position: absolute;
  top: calc(50% + 30px);
  transform: translateY(-50%);
  display: inline-block;
  border-width: 10px;
  background-color: #f2f2f2;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  color: #00a0e1;
  line-height: 60px;
  font-size: 36px;
  text-align: center;
  &:hover {
    background-color: #00a0e1;
    color: #fff;
  }
}
.swiper-container {
  width: 100%;

  margin: 20px auto;
  cursor: grab;
  padding-bottom: fh(60vh, pc);
}
.swiper-pagination {
  bottom: fh(30vh, pc);
}
.swiper-slide {
  text-align: center;
  font-size: 18px;
  background: #fff;

  /* Center slide text vertically */
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
}
.append-buttons {
  text-align: center;
  margin-top: 20px;
}
.append-buttons a {
  display: inline-block;
  border: 1px solid #007aff;
  color: #007aff;
  text-decoration: none;
  padding: 4px 10px;
  border-radius: 4px;
  margin: 0 10px;
  font-size: 13px;
}
.calendar-view {
  position: relative;
  .more-btn {
    margin-left: 50%;
    transform: translateX(-50%);
  }
  .calendar-item {
    &:hover .item-time {
      .icon01 {
        display: none;
      }
      .icon11 {
        display: block;
      }
      .time-text {
        .year {
          color: #fff;
        }
        .day {
          color: #00a0e1;
        }
        .month {
          color: #fff;
        }
      }
    }
    &:hover .item-text::before {
      background-color: #ff9b1e;
    }
    .item-text {
      position: relative;
      padding: fh(40vh, pc) fw(50vw, pc);
      font-size: fh(24vh, pc);
      line-height: fh(36vh, pc);
      font-weight: bold;
      color: #2a2a2a;
      border-top: 1px solid #f0f0f0;
      &::before {
        position: absolute;
        content: "";
        left: 50%;
        transform: translateX(-50%);
        width: fw(18vw, pc);
        height: fw(18vw, pc);
        font-size: fh(18vh, pc);
        background-color: #a9a9a9;
        border: 3px solid #f0f0f0;
        top: fw(-9vw, pc);
        border-radius: 50%;
      }
    }
    .item-time {
      position: relative;
      width: fw(172vw, pc);
      left: 50%;
      transform: translateX(-50%);
      margin-bottom: fh(28vh, pc);
      img {
        width: 100%;
        display: block;
      }
      .icon11 {
        display: none;
      }
      .time-text {
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding-top: fh(20vh, pc);
        padding-bottom: fh(42vh, pc);
        > div {
          width: 100%;
          text-align: center;
          color: #a9a9a9;
        }
        .year {
          font-size: fh(32vh, pc);
          line-height: fh(36vh, pc);
        }
        .day {
          font-size: fh(60vh, pc);
          // line-height: fh(85vh, pc);
          font-weight: bold;
        }
        .month {
          font-size: fh(20vh, pc);
          line-height: fh(30vh, pc);
        }
      }
    }
  }
}

#home {
  position: relative;
  width: 100%;
  .index-title {
    font-size: fh(60vh, pc);
    color: #2a2a2a;
    line-height: fh(72vh, pc);
    margin-bottom: fh(40vh, pc);
    font-weight: bold;
    &.news {
      margin-top: fh(64vh, pc);
      border-top: 1px solid #ccc;
      padding-top: 21px;
    }
    &.custom_class {
      border-top: 1px solid #ccc;
      margin-top: -29px;
      padding-top: 21px;
    }
  }
  .page-content {
    padding-top: fh(100vh, pc);
  }
  .cus_two {
    padding-top: 26px;
  }
  &::after {
    // content: "";
    position: absolute;
    left: 0;
    top: 0;
    z-index: -1;
    width: 100%;
    height: 100%;
    background: url("../assets/images/home-bg.jpg") no-repeat;
    background-size: 100% auto;
    background-position: center 0;
  }

  .page {
    // padding: fh(152vh, pc) fw(80vw, pc) 0 fw(80vw, pc);
    background: #fff;

    // margin-top: -23px;

    //   #home .page::after {
    // content: "";
    // position: absolute;
    // left: 0;
    // top: 0;
    // z-index: -1;
    // width: 100%;
    // height: max-content;
    // background: url("../assets/images/home-bg.jpg") no-repeat;
    // background-size: cover;
    // background-position: center 0;
    // }
    .banner-big-info {
      position: absolute;
      width: 45%;
      height: 35%;
      background: rgb(10, 172, 236);
      background-image: url(https://lanhu-dds-backend.oss-cn-beijing.aliyuncs.com/merge_image/imgs/49dacf59dfa34990ab7098d396592c3a_mergeImage.png);
      right: 0;
      bottom: 0;

      .banner-big-info-who {
        position: absolute;
        top: -48px;
        left: 24px;
        color: rgba(255, 255, 255, 1);
        font-size: 80px;
        font-family: "Helvetica-BoldOblique";
      }

      .banner-big-info-content {
        color: rgba(255, 255, 255, 1);
        font-size: 15px;
        font-family: "PingFangSC-Medium";
        padding: 40px;
        line-height: 24px;
      }

      .banner-big-info-more {
        color: rgba(255, 255, 255, 1);
        font-size: 14px;
        font-family: "PingFangSC-Medium";
        position: absolute;
        right: 30px;
        bottom: 40px;
      }
    }
  }

  .page-content {
    width: fw(1520vw, pc);
    margin: 0 auto;
    background-color: #fff;
    // padding: 0 fw(80vw, pc) fh(40vh, pc) fw(80vw, pc);
    .program-view {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;

      .program-item {
        position: relative;
        width: 100%;
        overflow: hidden;
        margin-bottom: fh(30vh, pc);
        display: flex;
        height: fh(320vh, pc);
        border-radius: 22px;
        &::before {
          content: "";
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
          background-color: rgba(0, 0, 0, 0.2);
          z-index: 1;
        }
        img {
          width: 50%;
          position: relative;
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;
          margin-right: fw(20vw, pc);
        }
        .item-info {
          width: 50%;
          color: #333;
          display: flex;
          flex-flow: column;
          justify-content: space-between;
          position: relative;
          z-index: 2;
          .item-title {
            font-size: fh(46vh, pc);
            line-height: fh(50vh, pc);
            margin-bottom: fh(40vh, pc);
          }
          .custom_program {
            font-size: fh(29vh, pc) !important;
          }
          .item-content {
            font-size: fh(24vh, pc);
            line-height: fh(36vh, pc);
          }
          .item-btn {
            width: fw(200vw, pc);
            height: fh(40vh, pc);
            line-height: fh(40vh, pc);
            font-size: fh(16vh, pc);
            background: #0077d4;
            border-radius: fh(20vh, pc);
            text-align: center;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #fff;

            i {
              margin-left: fw(4vw, pc);
            }

            &:hover {
              cursor: pointer;
              background-color: rgba(0, 120, 212, 0.8);
            }
          }
        }
        &:nth-child(1),
        &:nth-child(2),
        &:nth-child(3) {
          img {
            width: 100%;
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 50%;
            height: 100%;
            width: auto;
            transform: translateX(-50%);
            display: block;
          }
          .item-info {
            position: absolute;
            width: 90%;
            left: 50%;
            transform: translateX(-50%);
            bottom: fh(40vh, pc);
            color: #fff;
            .item-title {
              font-size: fh(36vh, pc);
              line-height: fh(43vh, pc);
            }
            .item-content {
              display: none;
            }
          }
          &:nth-child(2),
          &:nth-child(3) {
            .item-info {
              width: 80%;
            }
          }
        }

        &:nth-child(1) {
          width: fw(750vw, pc);
          height: fh(500vh, pc);
        }

        &:nth-child(2) {
          width: fw(365vw, pc);
          height: fh(500vh, pc);
        }

        &:nth-child(3) {
          width: fw(365vw, pc);
          height: fh(500vh, pc);
        }
      }
    }
    .news-view {
      padding: fh(20vh, pc) 0;
      padding-bottom: fh(120vh, pc);
      .news-content {
        width: 100%;
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
      }

      .news-item {
        width: fw(364vw, pc);
        .img-view {
          width: 100%;
          height: fh(240vh, pc);
          overflow: hidden;
          img {
            width: 100%;
          }
        }

        .news-title {
          font-size: fh(24vh, pc);
          color: #2a2a2a;
          line-height: fh(36vh, pc);
          margin: fh(20vh, pc) 0;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
          &:hover {
            cursor: pointer;
            color: #0077d4;
          }
        }
        .news-date {
          font-size: fh(24vh, pc);
          color: #999999;
          line-height: fh(30vh, pc);
        }
      }

      .more-btn {
        margin-top: fh(40vh, pc);
        position: relative;
        left: 50%;
        transform: translateX(-50%);
      }
    }
  }
  .home-bottom {
    height: fh(100vh, pc);
  }
  .all-line {
    background-color: #fff;
    width: 100%;
    padding: fh(30vh, pc) fw(200vw, pc);
    &.blue {
      background-color: rgba(0, 120, 212, 0.1);
      .program-view2 {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;

        .program-item {
          position: relative;
          width: 100%;
          overflow: hidden;
          // margin-bottom: fh(30vh, pc);
          display: flex;
          justify-content: space-between;
          height: fh(320vh, pc);
          &:nth-child(2) {
            border-top: 1px solid #e4e4e4;
            padding-top: fh(40vh, pc);
          }
          &:nth-last-child(1) {
            img {
              margin-left: fw(20vw, pc);
              margin-right: 0;
            }
          }
          img {
            position: relative;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            margin-right: fw(25vw, pc);
          }
          .item-info {
            width: 50%;
            width: 67%;
            color: #333;
            display: flex;
            flex-flow: column;
            justify-content: space-between;
            .item-title {
              font-size: fh(46vh, pc);
              line-height: fh(50vh, pc);
              margin-bottom: fh(40vh, pc);
              font-weight: bold;
            }
            .custom_about {
              font-size: fh(60vh, pc);
            }
            .item-title2 {
              font-size: fh(27vh, pc);
              line-height: fh(6vh, pc);
              margin-bottom: fh(10vh, pc);
              font-weight: bold;
            }
            .item-content {
              font-size: fh(24vh, pc);
              line-height: fh(36vh, pc);
            }
            .item-btn {
              width: fw(200vw, pc);
              height: fh(40vh, pc);
              line-height: fh(40vh, pc);
              font-size: fh(16vh, pc);
              background: #0077d4;
              border-radius: fh(20vh, pc);
              text-align: center;
              display: flex;
              align-items: center;
              justify-content: center;
              color: #fff;

              i {
                margin-left: fw(4vw, pc);
              }

              &:hover {
                cursor: pointer;
                background-color: rgba(0, 120, 212, 0.8);
              }
            }
          }
          &:nth-last-child(1) {
            img {
              margin-left: fw(0vw, pc);
              margin-right: 0;
              margin-right: 6%;
              width: calc(50% - 1.03vw);
              // width: 251px;
              // height: 251px;
              width: fh(320vh, pc);
              height: fh(320vh, pc);
              border-radius: 50%;
            }
            .item-info {
              margin-right: 0.8vw;
            }
          }
        }
      }
    }
    &.media {
      padding: fh(0vh, pc) fw(200vw, pc);
      margin-top: fh(110vh, pc);
      .media-view {
        .more-btn {
          position: absolute;
          bottom: fh(-80vh, pc);
          left: 50%;
          transform: translateX(-50%);
        }
        .media-title {
          font-size: fh(60vh, pc);
          color: #2a2a2a;
          line-height: fh(72vh, pc);
          margin-top: fh(-150vh, pc);
          font-weight: 700;
        }
        .custom_mud {
          border-top: 1px solid #ccc;
          padding-top: 21px;
        }
        .media-content {
          position: relative;
          min-height: fh(700vh, pc);
          padding: fh(10vh, h5);
          overflow: hidden;
          .media-item {
            position: absolute;
            overflow: hidden;
            .media-img {
              display: block;
              width: 100%;
              height: 100%;
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
            }
            img.media-img {
              cursor: pointer;
            }
            &.item5 {
              bottom: 0;
              right: 0;
              width: fw(1000vw, pc);
              height: fh(304vh, pc);
            }
            &.item4 {
              bottom: 0;
              left: 0;
              width: fw(490vw, pc);
              height: fh(304vh, pc);
            }
            &.item3 {
              top: fh(362vh, pc);
              right: 0;
              width: fw(492vw, pc);
              height: fh(303vh, pc);
            }
            &.item2 {
              top: fh(38vh, pc);
              right: 0;
              width: fw(492vw, pc);
              height: fh(303vh, pc);
            }
            &.item1 {
              top: fh(38vh, pc);
              left: 0;
              width: fw(1000vw, pc);
              height: fh(628vh, pc);
              .model {
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
                height: 100%;
                background-color: rgba(0, 0, 0, 0.445);
                z-index: 5;
                img {
                  position: absolute;
                  top: 50%;
                  left: 50%;
                  width: fw(60vw, pc);
                  height: fw(60vw, pc);
                  display: block;
                  transform: translate(-50%, -50%);
                  &:hover {
                    opacity: 0.8;
                    cursor: pointer;
                  }
                }
              }
            }
          }
        }
      }
    }
    .ship-view {
      display: flex;
      width: 100%;
      align-items: flex-start;
      justify-content: space-between;
      .ship-item {
        width: 32%;
        background-color: #fff;
        background-color: rgba(0, 119, 212, 0.1);
        display: flex;
        justify-content: center;
        align-items: center;
        height: 240px;
        padding-left: 20px;
        border-radius: 20px;
        img {
          // width: 100%;
          // display: block;
          width: 180px;
          height: 180px;
          border-radius: 50%;
        }
        .item-title {
          font-weight: bold;
          font-size: fh(30vh, pc);
          color: #2a2a2a;

          margin-top: fh(30vh, pc);
          width: 100%;
          text-align: center;
          text-align: left;
          overflow-wrap: break-word;
          margin-left: 15px;
        }
        .ship-icon {
          width: fw(32vw, pc);
          margin: fh(20vh, pc) auto;
        }
        i {
          width: fw(40vw, pc);
          height: fw(40vw, pc);
          line-height: fw(40vw, pc);
          font-size: fh(20vh, pc);
          text-align: center;
          border-radius: 50%;
          background-color: #0077d4;
          color: #fff;
          margin: 0 auto;
          display: block;
          margin-bottom: fh(20vh, pc);
          &:hover {
            cursor: pointer;
            background-color: rgba(0, 120, 212, 0.8);
          }
        }
      }
    }
  }

  //@at-root
  .time {
    font-size: 13px;
    color: #999;
  }

  .bottom {
    margin-top: 13px;
    line-height: 12px;
  }

  .button {
    padding: 0;
    float: right;
  }

  .image {
    width: 100%;
    display: block;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }

  .clearfix:after {
    clear: both;
  }

  .el-carousel {
    width: 100%;
    min-height: 60vh;

    .banner-bg {
      position: relative;
      width: 100%;
      height: 100%;
      background: url("../assets/images/home-banner01.png") no-repeat;
      background-size: 100% 100%;
      &:before {
        content: "";
        display: block;
        background: linear-gradient(180deg, rgba(0, 0, 0, 0.25) 0%, rgba(0, 0, 0, 0.4) 100%);
        mix-blend-mode: normal;
        position: absolute;
        left: 50%;
        top: 0;
        width: 100vw;
        height: 100%;
        transform: translateX(-50%);
        z-index: 0;
      }

      .banner-info {
        width: 90%;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        bottom: fh(88vh, pc);
        color: #fff;

        .info-title {
          font-size: fh(60vh, pc);
          line-height: fh(72vh, pc);
          font-weight: bold;
        }

        .info-content {
          font-size: fh(20vh, pc);
          line-height: fh(30vh, pc);
          margin-top: fh(20vh, pc);
          display: -webkit-box; /* 使用弹性盒模型布局 */
          -webkit-line-clamp: 3; /*显示的行数*/
          -webkit-box-orient: vertical; /* 垂直方向排列*/
          overflow: hidden;
          text-overflow: ellipsis; /* 超出部分显示省略号*/
        }

        .info-btn {
          width: fw(200vw, pc);
          height: fh(40vh, pc);
          line-height: fh(40vh, pc);
          font-size: fh(16vh, pc);
          background: #0077d4;
          border-radius: fh(20vh, pc);
          text-align: center;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-top: fh(46vh, pc);

          i {
            margin-left: fw(4vw, pc);
          }

          &:hover {
            cursor: pointer;
            background-color: rgba(0, 120, 212, 0.8);
          }
        }
      }
    }

    img {
      height: inherit;
      width: 100%;
      display: block;
    }
  }
}

#home.h5 {
  .all-line.media .media-view .media-content {
    padding: 0;
  }
  .page {
    padding-top: fh(45vh, h5) !important;
    .banner-info {
      bottom: fh(10vh, h5) !important;
    }
    .info-title {
      font-size: fh(16vh, h5) !important;
      line-height: fh(18vh, h5) !important;
    }
    .info-content {
      display: none !important;
    }
    .info-btn {
      width: fw(120vw, h5) !important;
      margin-top: fh(10vh, h5) !important;
      opacity: 0.8;
    }
    .el-carousel {
      min-height: max-content;
    }
  }
  .index-title {
    font-size: fh(20vh, h5) !important;
    line-height: fh(36vh, h5) !important;
    margin-bottom: fh(15vh, h5);
    &.news {
      margin-top: fh(26vh, h5) !important;
    }
    &.custom_class {
      border-top: none !important;
    }
  }
  .media-view {
    margin: fh(50vh, h5) 0 !important;
    .more-btn {
      width: fw(120vw, h5) !important;
      margin-top: fh(10vh, h5) !important;
    }
    .media-content {
      height: max-content !important;
      margin-top: -30px;
    }
    .media-title {
      font-size: fh(20vh, h5) !important;
      line-height: fh(24vh, h5) !important;
      margin-bottom: fh(20vh, h5) !important;
    }
    .media-item {
      width: 100% !important;
      height: max-content !important;
      position: relative !important;
      video {
        width: 100%;
        position: relative !important;
        top: 0 !important;
        left: 0 !important;
        right: 0 !important;
        bottom: 0 !important;
        transform: translate(0) !important;
      }
      .media-img {
        width: 100%;
        position: relative !important;
        top: 0 !important;
        left: 0 !important;
        right: 0 !important;
        bottom: 0 !important;
        transform: translate(0) !important;
      }
      .model {
        img {
          width: fw(50vw, h5) !important;
          height: fw(50vw, h5) !important;
        }
      }
    }
  }
  .news-view {
    .more-btn {
      width: fw(120vw, h5) !important;
      margin-top: fh(10vh, h5) !important;
    }
    .news-content {
      flex-wrap: wrap;

      .news-item {
        width: 100%;
        margin-bottom: fh(10vh, h5) !important;
        background-color: #f5f5f5;
        border-radius: 10px;
        overflow: hidden;
        .img-view {
          height: max-content;
        }
        .news-title {
          padding: 0 2%;
          font-size: fh(16vh, h5) !important;
          line-height: fh(20vh, h5) !important;
        }
        .news-date {
          padding: 2%;
          padding-top: 0;
          padding-bottom: 6%;
          font-size: fh(16vh, h5) !important;
        }
      }
    }
  }
  .page-content {
    width: 96%;
    padding-top: fh(20vh, h5) !important;
    .item-btn {
      width: fw(120vw, h5) !important;
      margin-top: fh(10vh, h5) !important;
    }
    .program-view {
      .program-item {
        width: 100%;
        height: max-content !important;
        border-radius: fh(20vh, h5) !important;
        img {
          position: static !important;
          margin-right: 0;
          display: block;
          width: 100%;
          transform: translateX(0%);
        }
        .item-info {
          bottom: 6%;
          width: 90% !important;
        }
        .item-title {
          font-size: fh(16vh, h5) !important;
          line-height: fh(18vh, h5) !important;
          margin-bottom: fh(10vh, h5) !important;
        }
      }
    }
  }
  .calendar-view {
    .swiper-pagination {
      bottom: fh(6vh, h5) !important;
    }
    .swiper-container {
      padding-bottom: fh(16vh, h5) !important;
      margin-bottom: 0;
    }
    .swiper-button-prev,
    .swiper-button-next {
      display: none;
    }
    .more-btn {
      width: fw(120vw, h5) !important;
      margin-top: fh(10vh, h5) !important;
    }
    .item-text {
      padding: fh(10vh, h5) fw(10vw, h5) !important;
      font-size: fh(18vh, h5) !important;
      line-height: fh(22vh, h5) !important;
      &::before {
        width: fw(10vw, h5) !important;
        height: fw(10vw, h5) !important;
        transform: translate(-50%, -35%);
      }
    }
    .calendar-item {
      width: 100%;
      .item-time {
        width: 36%;
      }
      .time-text {
        .day {
          font-size: fh(30vh, h5) !important;
        }
      }
    }
  }

  .all-line {
    width: 100%;
    margin: 0 auto;
    padding: fh(16vh, h5) 3% !important;
    .ship-view {
      flex-wrap: wrap !important;
      .ship-item {
        width: 100%;
        &:nth-last-child(1) {
          margin-top: fh(16vh, h5) !important;
        }
        &:nth-last-child(2) {
          margin-top: fh(16vh, h5) !important;
        }
        .item-title {
          font-size: fh(20vh, h5) !important;
          line-height: fh(20vh, h5) !important;
          margin-top: fh(10vh, h5) !important;
        }
        .ship-icon {
          width: fw(30vw, h5);
          margin: fh(10vh, h5) auto;
        }
      }
    }
    .program-view2 {
      .program-item {
        flex-wrap: wrap !important;
        height: max-content;
        &:nth-last-child(1) {
          padding-top: fh(10vh, h5) !important;
          margin: 0;
          .item-btn {
            width: fw(120vw, h5) !important;
            margin-bottom: fh(10vh, h5) !important;
          }
        }
        .item-btn {
          width: fw(120vw, h5) !important;
          margin-top: fh(10vh, h5) !important;
        }
        .item-title {
          font-size: fh(20vh, h5) !important;
          line-height: fh(20vh, h5) !important;
          margin-bottom: fh(10vh, h5) !important;
          padding-top: fh(10vh, h5) !important;
          font-weight: bold;
        }
        .item-title2 {
          font-size: fh(16vh, h5) !important;
          line-height: fh(20vh, h5) !important;
          margin-bottom: fh(10vh, h5) !important;
          padding-top: fh(10vh, h5) !important;
          font-weight: bold;
        }
        .item-content {
          font-size: fh(16vh, h5) !important;
          line-height: fh(20vh, h5) !important;
        }
        img {
          // width: 100% !important;
          border-radius: 0px !important;
          border-radius: 10px !important;
          margin: 0 auto !important;
        }
        .item-info {
          width: 100%;
        }
      }
    }
  }

  ::v-deep .hot-article {
    width: 100%;
  }

  ::v-deep .book-view {
    width: 100%;
  }

  .banner-item {
    .item-content .content-title {
      .title1 {
        width: max-content;
        padding-right: fw(10vw, h5);
      }

      .title2 {
        padding: 0;
        line-height: 20px;
        font-size: 16px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        // 下面这句用来控制行数
        line-clamp: 1;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        flex: 1;
      }
    }
  }
}
</style>
